import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestsComponent } from './pages/requests/requests.component';
import { RequestDetailComponent } from './pages/request-detail/request-detail.component';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';

const routes: Routes = [
  {
    path: '',
    component: RequestsComponent,
    data: { title: routeMetaData.requests.title },
  },
  {
    path: ':id',
    component: RequestDetailComponent,
    data: { title: routeMetaData.requests.title },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RequestsRoutingModule {}
